/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamRevisionLang202,
  PostApiV1ExamRevisionLang400,
  PostApiV1ExamRevisionLang401,
  PostApiV1ExamRevisionLang404,
  PostApiV1ExamRevisionLang500,
  PostApiV1ExamRevisionLangMutationRequest,
  PostApiV1ExamRevisionLangMutationResponse,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLang.ts";
import { createBotExamLangViewModelSchema } from "../createBotExamLangViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamRevisionLang202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLang202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamRevisionLang400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLang400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamRevisionLang401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLang401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamRevisionLang404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLang404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamRevisionLang500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLang500>;

export const postApiV1ExamRevisionLangMutationRequestSchema = z.lazy(
  () => createBotExamLangViewModelSchema,
) as unknown as ToZod<PostApiV1ExamRevisionLangMutationRequest>;

export const postApiV1ExamRevisionLangMutationResponseSchema = z.lazy(
  () => postApiV1ExamRevisionLang202Schema,
) as unknown as ToZod<PostApiV1ExamRevisionLangMutationResponse>;
